import { render, staticRenderFns } from "./Promo.vue?vue&type=template&id=8500ecb8&scoped=true&"
import script from "./Promo.vue?vue&type=script&lang=ts&"
export * from "./Promo.vue?vue&type=script&lang=ts&"
import style0 from "./Promo.vue?vue&type=style&index=0&id=8500ecb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8500ecb8",
  null
  
)

export default component.exports